var _circle, _circle2, _g, _path, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOccupancySensor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 63,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#F5F5F5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#FF8080",
  className: "occupancy-sensor_svg__connection-status"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "gray",
  className: "occupancy-sensor_svg__no-status"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49 46 7 7M56 46l-7 7"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "occupancy-sensor_svg__a",
  width: 20,
  height: 20,
  x: 43,
  y: 17,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M43 17h20v20H43z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  className: "occupancy-sensor_svg__no-battery-status",
  mask: "url(#occupancy-sensor_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M52.167 28.667h1.666v-5h-1.666zM53 32q.354 0 .594-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594T53 32m-3.333 3.334a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.594V21.167q0-.354.24-.594t.594-.24h1.666v-1.666h3.334v1.667h1.666q.354 0 .594.24.24.239.24.593V34.5q0 .354-.24.594a.8.8 0 0 1-.594.24zm.833-1.667h5V22h-5z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#occupancy-sensor_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#113E57",
  d: "M34.928 23.851a8 8 0 0 0-1.188-.586 5.14 5.14 0 0 0 1.283-3.407c0-1.383-.5-2.64-1.459-3.617-.958-.977-2.16-1.508-3.497-1.508s-2.551.517-3.497 1.494c-.945.992-1.458 2.235-1.458 3.617 0 1.284.446 2.43 1.256 3.379a6.7 6.7 0 0 0-1.27.614c-1.646 1.034-2.565 2.625-2.565 4.482v.643c0 .097 0 .195.014.293 0 .167.027.74.04 2.597 0 1.452.648 2.793 1.729 3.658v5.264c0 2.109 1.66 3.826 3.7 3.826h3.982c2.04 0 3.7-1.717 3.7-3.826V35.51c1.107-.88 1.769-2.248 1.769-3.728v-3.477c0-1.857-.905-3.448-2.566-4.482zm-6.643-5.822c.5-.517 1.094-.768 1.782-.768.69 0 1.283.251 1.783.768.5.516.742 1.13.742 1.843 0 .712-.243 1.326-.742 1.843-.5.517-1.094.768-1.783.768s-1.282-.252-1.782-.768a2.55 2.55 0 0 1-.742-1.843c0-.712.243-1.327.742-1.843m6.778 13.781c0 .866-.486 1.62-1.188 1.969-.351.181-.594.516-.594.921v6.102c0 .726-.567 1.313-1.27 1.313H28.03c-.702 0-1.27-.587-1.27-1.313V34.7c0-.377-.215-.726-.553-.893a2.2 2.2 0 0 1-1.175-1.955c-.013-2.318-.04-2.863-.054-2.876v-.643c0-.977.46-1.76 1.39-2.331.92-.573 2.148-.866 3.66-.866s2.727.293 3.66.866c.917.572 1.39 1.354 1.39 2.331v3.477z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  className: "occupancy-sensor_svg__full-battery",
  mask: "url(#occupancy-sensor_svg__mask0_38170_106501)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#14B814",
  d: "M49.833 35.667a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.594V21.5q0-.354.24-.594t.593-.24H51.5V19h3.333v1.667H56.5q.354 0 .594.24.24.239.24.593v13.333q0 .354-.24.594a.8.8 0 0 1-.594.24z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg",
  className: "occupancy-sensor_svg__low-battery",
  mask: "url(#occupancy-sensor_svg__mask1_951_12431)",
  transform: "translate(43 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8080",
  d: "M9.167 11.667h1.666v-5H9.167zM10 15q.354 0 .594-.24t.24-.594a.8.8 0 0 0-.24-.593.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.593q0 .355.24.594.24.24.594.24m-3.333 3.333a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593V4.167q0-.356.24-.594.24-.24.594-.24h1.666V1.667h3.334v1.666h1.666q.354 0 .594.24t.24.594V17.5q0 .354-.24.594a.8.8 0 0 1-.594.24zm.833-1.666h5V5h-5z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  className: "occupancy-sensor_svg__medium-battery",
  mask: "url(#occupancy-sensor_svg__mask0_951_9234)",
  transform: "translate(43 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F9C030",
  d: "M6.667 18.333a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.593V4.167q0-.356.24-.594.24-.24.594-.24h1.666V1.667h3.334v1.666h1.666q.354 0 .594.24t.24.594V17.5q0 .354-.24.594a.8.8 0 0 1-.594.24zM7.5 15h5V5h-5z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "occupancy-sensor_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14 13.667h32v32H14z"
})))));
export default SvgOccupancySensor;